// @flow

import { formatDate, useLocalizedWeekDayName } from '@tectonics/utils/date';
import { usePendingIncomingPayment, getSafeDueDate } from '@tectonics/prs/incoming-payment';
import { VOUCHER_DUE_DATE_FORMAT } from './due-date-format';

type VoucherDueDate = {|
  +formattedDueDate: string,
  +weekDay: string,
|};

export function useVoucherDueDate(): VoucherDueDate {
  const incomingPayment = usePendingIncomingPayment();
  const dueDate = getSafeDueDate(incomingPayment);

  return {
    formattedDueDate: formatDate({ date: dueDate, formatString: VOUCHER_DUE_DATE_FORMAT }),
    weekDay: useLocalizedWeekDayName({ date: dueDate, skipWeekend: true, useShortName: true }),
  };
}
